import { render } from "./StudentView.vue?vue&type=template&id=720254f4&scoped=true"
import script from "./StudentView.vue?vue&type=script&lang=js"
export * from "./StudentView.vue?vue&type=script&lang=js"

import "./StudentView.vue?vue&type=style&index=0&id=720254f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720254f4"]])

export default __exports__